/**
 * ElecBid — chat picker preferences shared by the assessment's Scope Chat and
 * the quote editor's Refine chat (localStorage keys sc-model / sc-think, so the
 * picker follows the tech between the two screens).
 *
 * Thinking defaults ON ("standard"): Dylan asked to WATCH the AI think while it
 * works (2026-08-13), and with the old "off" default the live 💭 stream both
 * chats already render simply never had anything to show. The one-time v2
 * migration flips a stored "off" — the old shipped default, which almost nobody
 * chose on purpose — to "standard". A tech who turns it off again after the
 * flip stays off: the marker key makes the migration run exactly once.
 */
export function initialThinkPref() {
  try {
    if (!localStorage.getItem("sc-think-v2")) {
      localStorage.setItem("sc-think-v2", "1");
      if ((localStorage.getItem("sc-think") || "off") === "off") {
        localStorage.setItem("sc-think", "standard");
      }
    }
    return localStorage.getItem("sc-think") || "standard";
  } catch {
    return "standard";
  }
}
